var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-2" },
    [
      _vm.isLoading
        ? _c("Spinner")
        : _c(
            "div",
            [
              _c("OperationsBreadcrumb", { attrs: { links: _vm.links } }),
              !!_vm.errorMessage.message
                ? _c("Message", {
                    attrs: {
                      message: _vm.errorMessage.message,
                      icon: _vm.errorMessage.icon,
                    },
                  })
                : _c("div", [
                    _c("div", { staticClass: "columns" }, [
                      _c("div", { staticClass: "column is-three-quarters" }, [
                        _c("div", { staticClass: "card-item mt-5 mb-0" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "is-flex is-justify-content-space-between is-align-items-center",
                            },
                            [
                              _c("h3", { staticClass: "has-text-black" }, [
                                _vm._v(
                                  _vm._s(
                                    `${_vm.client.name} ${_vm.client.lastName}`
                                  )
                                ),
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "is-flex is-align-items-center has-text-grey",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          _vm.operation.isActive === true
                                            ? "enabled"
                                            : "disabled"
                                        )
                                      ) +
                                      " "
                                  ),
                                  _c("i", {
                                    staticClass: "ml-1 fa-solid fa-circle",
                                    class: [
                                      _vm.operation.isActive === true
                                        ? "has-text-primary"
                                        : "has-text-danger",
                                    ],
                                  }),
                                  _vm.operation.isVerified
                                    ? _c("i", {
                                        staticClass:
                                          "ml-1 has-text-primary fa-regular fa-circle-check",
                                      })
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            [
                              _vm.operation.companyOperationId
                                ? _c(
                                    "b-tag",
                                    {
                                      staticClass: "mr-4 mb-2",
                                      attrs: {
                                        type: "is-primary is-light",
                                        icon: "fa-solid fa-tag",
                                        "data-cy":
                                          "resume-company-operation-id",
                                        rounded: "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.operation.companyOperationId
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.operation.type
                                ? _c(
                                    "b-tag",
                                    {
                                      staticClass: "mr-4 mb-2",
                                      attrs: {
                                        type: "is-primary is-light",
                                        icon: _vm.iconType[_vm.operation.type],
                                        "data-cy": "resume-operation-type",
                                        rounded: "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.operation.type) + " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.operation.approvedAmount
                                ? _c(
                                    "b-tag",
                                    {
                                      staticClass: "mr-4 mb-2",
                                      attrs: {
                                        type: "is-primary is-light",
                                        icon: "fa-solid fa-sack-dollar",
                                        "data-cy": "resume-approved-amount",
                                        rounded: "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatApprovedAmount(
                                              _vm.operation.approvedAmount
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.lastInvestor
                                ? _c(
                                    "b-tag",
                                    {
                                      staticClass: "mr-4 mb-2",
                                      attrs: {
                                        type: "is-primary is-light",
                                        icon: "fa-solid fa-address-book",
                                        "data-cy": "resume-investor",
                                        rounded: "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.lastInvestor) + " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "column" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "card-item mt-5 mb-0 py-2 summary-card",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "is-flex is-align-items-center mb-1",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "icon-item is-flex is-align-items-center is-justify-content-center",
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa-solid fa-dollar-sign has-text-primary is-size-5",
                                    }),
                                  ]
                                ),
                                _c("span", [
                                  _c(
                                    "h3",
                                    {
                                      staticClass:
                                        "has-text-black is-size-6 mr-2",
                                    },
                                    [_vm._v(_vm._s(_vm.$t("summary")) + " ")]
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "is-flex is-flex-direction-column is-justify-content-center is-align-items-flex-start summary-tags",
                              },
                              [
                                _c(
                                  "b-tag",
                                  {
                                    staticClass: "mr-4 mb-2",
                                    attrs: {
                                      type: "is-light",
                                      icon: "fa-solid fa-arrow-down-wide-short",
                                      "data-cy": "resume-payment-stats",
                                      rounded: "",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " Cuotas pagadas: " +
                                        _vm._s(_vm.paymentsMade) +
                                        "/" +
                                        _vm._s(_vm.operation.termAsMonths) +
                                        " "
                                    ),
                                    _vm.hasUnbalancedOperations
                                      ? _c(
                                          "b-tooltip",
                                          {
                                            staticClass: "unbalanced-warning",
                                            attrs: {
                                              type: "is-light is-danger",
                                              label:
                                                "Existem pagamentos desequilibrados",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa-solid fa-circle-exclamation is-size-7 has-text-danger",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm.loadingState
                                  ? _c("iframe", {
                                      attrs: {
                                        src: "https://lottie.host/embed/d3431eb9-579c-41a2-9647-7c7b5f0efb04/PO5xTewVFt.json",
                                        height: "30",
                                        width: "30",
                                      },
                                    })
                                  : _c(
                                      "b-tag",
                                      {
                                        staticClass: "mr-4 mb-2",
                                        attrs: {
                                          type: "is-light",
                                          icon: "fa-solid fa-dollar-sign",
                                          "data-cy": "resume-payment-stats",
                                          rounded: "",
                                        },
                                      },
                                      [
                                        _vm.operation.remaining
                                          ?.remainingBalance
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("debtAmountLabel")
                                                ) +
                                                  ": " +
                                                  _vm._s(
                                                    _vm.formatApprovedAmount(
                                                      _vm.operation.remaining
                                                        .remainingBalance
                                                    )
                                                  )
                                              ),
                                            ])
                                          : _vm._e(),
                                        !_vm.operation.remaining
                                          ?.remainingBalance
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "remainingBalanceNotAvailable"
                                                  )
                                                )
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { attrs: { "data-cy": "operation-content-buttons" } },
                      [
                        _c("Tabs", {
                          staticClass: "mt-0",
                          attrs: { options: _vm.contentButtons },
                          scopedSlots: _vm._u([
                            {
                              key: "1",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card-item",
                                      attrs: { id: "operation-cap-management" },
                                    },
                                    [
                                      _c("AmortizationSchedule", {
                                        attrs: {
                                          "is-loading-new-date":
                                            _vm.loadingState,
                                          operation: _vm.operation,
                                          "date-for-amortization-schedule":
                                            _vm.dateForAmortizationSchedule,
                                          client: _vm.client,
                                          "show-table": false,
                                        },
                                        on: {
                                          "new-date": function ($event) {
                                            return _vm.getOperation($event)
                                          },
                                        },
                                      }),
                                      _c("OperationModifier", {
                                        staticClass: "mt-4",
                                        attrs: {
                                          "is-update-new-date":
                                            _vm.loadingState,
                                          operation: _vm.operation,
                                        },
                                        on: {
                                          "cap-modification":
                                            _vm.refreshOperation,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "0",
                              fn: function () {
                                return [
                                  _c("AmortizationSchedule", {
                                    attrs: {
                                      "is-loading-new-date": _vm.loadingState,
                                      operation: _vm.operation,
                                      "date-for-amortization-schedule":
                                        _vm.dateForAmortizationSchedule,
                                      client: _vm.client,
                                    },
                                    on: {
                                      "new-date": function ($event) {
                                        return _vm.getOperation($event)
                                      },
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _vm.operation.isActive === false
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "has-text-centered has-text-grey is-flex is-flex-direction-column is-justify-content-center is-align-items-center",
                            attrs: {
                              "data-cy": "inactive-operation-reason-card",
                            },
                          },
                          [
                            _c("iframe", {
                              staticClass: "animation-inactive",
                              attrs: {
                                src: "https://lottie.host/embed/69161ad5-fced-4882-9929-3558c12e0fad/1X6C7aQVOX.json",
                              },
                            }),
                            _c(
                              "p",
                              {
                                staticClass: "is-size-5 has-text-weight-medium",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("inactiveOperationMessage"))
                                ),
                              ]
                            ),
                            _c(
                              "b-tag",
                              {
                                attrs: {
                                  size: "is-small",
                                  rounded: "",
                                  type: "is-light is-warning",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    `${_vm.operationReasonForDisablingOrEnabling}`
                                  )
                                ),
                              ]
                            ),
                            _c("p", { staticClass: "is-size-6 mt-2" }, [
                              _vm._v(
                                " " + _vm._s(_vm.$t("contactInformation")) + " "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "mailto:g_producto_transformation_team@creditu.com",
                                  },
                                },
                                [_vm._v("Transformation Team Producto")]
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }